export const mapPlantillaFormToApi = (values: any) => {
    return {
        ...values,
        category: values.category?.value || values.category,
        business: values.business?.value || values.business,
    };
};

export const mapApiToPlantillaForm = (templateData: any, templatesForSelect: any[], googleBusinesses: any[] = []) => {
    let categoryObj = null;
    if (templateData.category) {
        const found = templatesForSelect.find((t: any) => t.value === templateData.category);
        categoryObj = found || { label: templateData.category, value: templateData.category };
    }

    let businessObj = null;
    if (templateData.location) {
        const found = googleBusinesses.find((b: any) => b.value === templateData.location);
        businessObj = found || { label: templateData.businessName || templateData.location, value: templateData.location };
    }

    return {
        name: templateData.name || '',
        message: templateData.message || '',
        category: categoryObj || '',
        business: businessObj || '',
    };
};
